import React from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import ReactFireComponent from '../react-fire-component/react-fire-component';

/** @class BuilderList
  * A class that displays (and for appropriate roles) allows
  * the selection of booth builders for a booth.
  * @prop {url} dataURL - the firebase database url to the booth
  * @prop {Object} builders - a map of builder's UIDs to names
  */
export default class BuilderList extends ReactFireComponent {
  /** @constructor
    * Constructs a new BuilderList
    */
  constructor(props) {
    super(props);
    this.state = {}
    this.toggleBuilderStatus = this.toggleBuilderStatus.bind(this);
  }
  /** @componentWillMount
    * Retrives the users/roles data from the firebase database.
    */
  componentWillMount() {
    const uid = firebase.auth().currentUser.uid;
    firebase.database().ref(`/users/${uid}`).once('value', snapshot => {
      this.setState({role: snapshot.val().role});
    });
    this.bindAsObject(`/users`, 'users');
  }
  /** @method componentWillUnmount
    * Releases the connection to the database
    */
  componentWillUnmount() {
    this.unbind('users');
  }
  /** @method toggleBuilderStatus
    * Toggles the status of the specified booth builder
    * @param {event} event the inciting event
    */
  toggleBuilderStatus(event) {
    const uid = event.target.value;
    const checked = event.target.checked;
    firebase.database().ref(`${this.props.dataURL}/builders/${uid}`).set(
      (checked) ? this.state.users[uid].name : null
    );
  }
  /** @method render
    * Renders the component
    */
  render() {
    if(this.state.role === 'Admin' || this.state.role === 'Expo Editor') {
      return (
        <div className="input-group">
          <label>Assigned Booth Builder(s)</label>
          <ul>
            {Object.keys(this.state.users || {}).map(key => (
              <div key={key}>
                <label htmlFor={key}>
                  <input type="checkbox" id={key}
                    value={key}
                    checked={this.props.builders && this.props.builders[key]}
                    onChange={this.toggleBuilderStatus}/>
                  {this.state.users[key].name}
                </label>
              </div>
            ))}
          </ul>
        </div>
      )
    } else {
      return (
        <div className="input-group">
          <label>Assigned Booth Builder(s)</label>
          <ul>
            {Object.keys(this.props.builders || {}).map(key => (
              <li key={key}>{this.props.builders[key]}</li>
            ))}
          </ul>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/booth-editor/builder-list.js